






















































































































import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import UserInterface from "@/types/app/IUser";
import Header from "@/types/app/header";
import NewInterface, { newInitialValue } from "@/types/app/news";
import formatMoney from "@/utils/formatMoney";
import applyCondition from "@/utils/applyCondition";
import formatDate from "@/utils/formatDate";
import { truncate } from "@/utils/truncate";
import Endpoint from "@/utils/endpoint";
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import CustomerService from "@/services/customerService";
import NewService from "@/services/newService";
import NewsHeader from "@/components/headers/header-news";
const namespace = "account";

@Component({
  methods: {
    formatMoney,
    formatDate,
    truncate,
  },
})
export default class NewsIndex extends BaseComponent {

  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;

  customerService = new CustomerService(this.$http);
  private newService = new NewService(this.$http);
  private endpoint = new Endpoint();
  loadingNews = false;
  headers: Header[] = NewsHeader.header;
  selectedNews: any[] = [];
  listAccountInvestor: VuetifySelectItems[] = []
  titleFilter = "";
  descriptionFilter = "";
  publishFilter = "";
  news: NewInterface[] = [];
  loadingPublished = false;

  async copyData(item: NewInterface) {
    try {
      const result = {
        id: item.id,
        authorId: item.authorId,
        title: item.title,
        description: item.description,
        published: item.published
      }
      await navigator.clipboard.writeText(JSON.stringify(result));
      this.showSuccess('Copied data to clipboard');
    } catch ($e) {
      alert('Cannot copy');
    }
  }

  async publishedNews(newId: string) {
    this.loadingNews = true;
    const result = await this.newService.publishedNews(newId);
    if(!result.hasErrors){
      this.showSuccess('News published successfully');
    }
    else  this.showError(result.messageErroDefault);
    
    this.loadingNews = false;

  }

  async mounted() {
    await this.handleNews();
  }

  async handleNews() {
    try {
      this.loadingNews = true;
      const [taskNews] = await Promise.all([this.newService.getNews()])
      this.news = taskNews;
    } catch (error) {
      ErrorService.onError(error);
    } finally {
      this.loadingNews = false;
    }
  }


  get filteredNews() {
    const conditions: any[] = [];
    if (this.titleFilter) {
      conditions.push((item: NewInterface) =>
        item.title?.toLowerCase()?.includes(this.titleFilter.toLowerCase())
      );
    }

    if (this.descriptionFilter) {
      conditions.push((item: NewInterface) =>
        item.description
          ?.toLowerCase()
          ?.includes(this.descriptionFilter.toLowerCase())
      );
    }

    if (this.publishFilter) {
      conditions.push((item: NewInterface) =>
        item.published
          ?.toString()
          ?.toLowerCase()
          ?.includes(this.publishFilter.toLowerCase())
      );
    }


    return applyCondition<NewInterface>(this.news, conditions);
  }

  showViewNew(news: NewInterface) {
    this.$router.push({
      name: "NewsForm",
      params: {
        newId: news.id,
        formType: 'view',
      }
    });
  }

  get hasSelectToDelete() {
    return this.selectedNews.length > 0;
  }

  async deleteNew() {
    this.$confirm("Do you really want to delete these news?").then(async (res) => {
      if (res) {
        const url = this.endpoint.account;
        this.loadingNews = true;
        const newsIds =  this.selectedNews.map((x) => x.id);
        const result = await this.newService.deleteNew(newsIds);
        if (!result.hasErrors)
        {
         
          this.news = this.news.filter(x => !newsIds.some(n => n == x.id));
          this.selectedNews = [];
          this.showSuccess("Deleted news with success!");
        }
        else this.showError(result.messageErroDefault);
        this.loadingNews = false;
      }
    });
  }

  showNewsForm() {
    this.$router.push({
      name: "NewsAddForm",
      params: {
        formType: 'create',
      }
    });
  }

  async exportCsv(onGrid = false) {

    let newArr = this.news.sort(
      (a, b) => new Date(a.entryDateTime).getTime() - new Date(b.entryDateTime).getTime()
    );
    if (onGrid) {
      newArr = this.filteredNews;
    }
    this.exportCSVFile([...newArr], `News-export`);
  }
}
